export default __webpack_public_path__ + "static/media/question001_answer_user002.dfcd2ed4.png";